import { useTheme } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useRouteMatch } from 'react-router-dom'
import { ProductWarrantyClaimRowResponse } from '@cbgms/api'

interface IWarrantyViewAction {
  row: ProductWarrantyClaimRowResponse
}

const ViewAction = ({ row }: IWarrantyViewAction) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const match = useRouteMatch()

  return (
    <Typography
      component={Link}
      sx={{ fontSize: '0.85rem', color: theme.palette.primary.main, cursor: 'pointer', fontWeight: 'bold' }}
      to={`${match.url}/edit/${row.Claim.UUID}`}
      data-testid='view-action'
    >
      {t('Concept_app.view').toLocaleUpperCase()}
    </Typography>
  )
}

export default ViewAction
